"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerifyCertificationBindRequest = void 0;
var VerifyCertificationBindRequest = /** @class */ (function () {
    function VerifyCertificationBindRequest() {
    }
    return VerifyCertificationBindRequest;
}());
exports.VerifyCertificationBindRequest = VerifyCertificationBindRequest;
;
//# sourceMappingURL=verifyCertificationBind.request.js.map